// 方案四：橙色系 - 活力、积极、职业导向
// 适合：职业规划平台，传达活力和积极向上的职业态度
export const professionalOrangeTheme = {
  colors: {
    'psychology-primary': '#EA580C',      // 深橙色 - 活力、积极、职业导向
    'psychology-secondary': '#C2410C',    // 更深橙色 - 辅助色，稳重
    'psychology-accent': '#F97316',       // 亮橙色 - 强调色，充满活力
    'psychology-calm': '#FFF7ED',         // 极浅橙色 - 背景色，温暖
    'psychology-warm': '#FFEDD5',         // 浅橙色 - 温暖背景
    'psychology-success': '#10B981',      // 绿色 - 成功、积极
    'psychology-info': '#0EA5E9',         // 蓝色 - 信息状态
    'psychology-warning': '#F59E0B',      // 橙色 - 警告状态
  },
  name: 'professional-orange',
  description: '橙色系主题 - 活力、积极、职业导向，适合职业规划平台'
}

